
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/follow_ranking",
      function () {
        return require("private-next-pages/company/follow_ranking/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/follow_ranking"])
      });
    }
  